import { baseService } from "service/base";

/*
 * Service for interacting with paginated full device models.
 */
class FullDeviceService {
  load(params = {}, options = {}) {
    return baseService.get("/api/devices/v2", params, options);
  }

  fetch(deviceId, params = {}, options = {}) {
    return baseService.get(`/api/device/v2/${deviceId}`, params, options);
  }
}

const fullDeviceService = new FullDeviceService();

export { fullDeviceService, FullDeviceService };
